<button
  type="button"
  aria-label="Show or hide columns"
  #btnColVis
  (keydown.escape)="colVisActive = false"
  (click)="colVisActive = !colVisActive"
  class="btn btn-outline-secondary"
  >
  Show / Hide
</button>
@if (colVisActive) {
  <div class="btn-collection" role="menu" [style.left]="btnColVis.offsetLeft + 'px'">
    @for (key of getColDefs(); track key) {
      <label class="btn-hide-show d-block" ngbButtonLabel>
        {{ columnDefs.get(key).displayName || key }}
        <input
          (keydown.escape)="colVisActive = false"
          type="checkbox"
          [(ngModel)]="columnDefs.get(key).isVisible"
          (change)="columnDefs.get(key).isVisible = $event.target.checked"
          ngbButton
          />
        </label>
      }
    </div>
  }
  @if (colVisActive) {
    <div (click)="colVisActive = false" class="dt-button-background"></div>
  }
